module.exports = __webpack_public_path__ + "img/sello_ens_declaracion_BASICA_RD311-2022.fc896aac.png";